
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/usps",
      function () {
        return require("private-next-pages/partners/usps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/usps"])
      });
    }
  